import { render, staticRenderFns } from "./selectProvinces.vue?vue&type=template&id=f832caa8"
import script from "./selectProvinces.vue?vue&type=script&lang=js"
export * from "./selectProvinces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports